module.exports = "/_next/static/images/devices-623bc4023830850bf0e7604444d20d0c.png";